import { Component } from "@angular/core";

@Component({
  selector: "app-precarga-sin-denuncia",
  template: "<router-outlet></router-outlet>",
})
export class PrecargaSinDenunciaComponent {}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/precarga-sin-denuncia/precarga-sin-denuncia.component.ts